/**
 * Page 1 of Create trigger drawer
 * Configure trigger event type
 */
import React from 'react';

import {TriggerScopeType} from '../../../../generated/graphql';
import {FilterKey, Update, ValueFilter} from '../../../../util/filters';
import {Select} from '../../../Form/Select';
import {TriggerRootFilter} from '../TriggerEventConfiguration';
import {
  EventTriggeringConditionType,
  Trigger,
  triggerOptions,
  triggers as triggersMap,
} from '../TriggerEventTypes';
import {OptionType} from '../utils';
import * as S from './CreateTriggerDrawerLoaded.styles';

const onSelectTrigger = (
  projectID: string,
  artifactCollectionID: string | undefined,
  val: EventTriggeringConditionType,
  setTrigger: (val: Trigger) => void,
  setEventTriggeringConditionType: (val: EventTriggeringConditionType) => void,
  setTriggerScopeType: (val: TriggerScopeType) => void,
  setTriggerScopeID: (val: string) => void,
  setTriggerArtifactCollectionName: (val: string) => void
) => {
  const selectedTrigger = triggersMap[val];
  setTrigger(selectedTrigger);
  setEventTriggeringConditionType(val);
  setTriggerScopeType(selectedTrigger.defaultEventScopeType);
  setTriggerArtifactCollectionName('');
  if (
    artifactCollectionID &&
    selectedTrigger.defaultEventScopeType ===
      TriggerScopeType.ArtifactCollection
  ) {
    setTriggerScopeID(artifactCollectionID);
  } else {
    setTriggerScopeID('');
  }
};

type DrawerPageEventConfigurationProps = {
  customTriggerOptions?: OptionType[];
  entityName: string;
  projectName: string;
  projectID: string;
  artifactCollectionID?: string;
  trigger?: Trigger;
  triggerScopeType?: TriggerScopeType;
  triggerScopeID: string;
  setTrigger: (val: Trigger) => void;
  setEventTriggeringConditionType: (val: EventTriggeringConditionType) => void;
  setTriggerScopeType: (val: TriggerScopeType) => void;
  setTriggerScopeID: (val: string) => void;
  setTriggerArtifactCollectionName: (val: string) => void;
  filters: TriggerRootFilter;
  setFilters: (val: TriggerRootFilter) => void;
};

export const DrawerPageEventConfiguration = ({
  customTriggerOptions,
  entityName,
  projectName,
  projectID,
  artifactCollectionID,
  trigger,
  triggerScopeType,
  triggerScopeID,
  setTrigger,
  setEventTriggeringConditionType,
  setTriggerScopeType,
  setTriggerScopeID,
  filters,
  setFilters,
  setTriggerArtifactCollectionName,
}: DrawerPageEventConfigurationProps) => {
  const EventConfiguration = trigger?.eventConfiguration;
  return (
    <>
      <S.PageLabelRow>
        Step 1 of 3 - Select a type of event to trigger this automation.
      </S.PageLabelRow>
      <S.LabelRow>
        <S.Label>Event type</S.Label>
      </S.LabelRow>
      <Select<OptionType | null>
        filterOption={option =>
          option.value !== EventTriggeringConditionType.UpdateArtifactAlias
        }
        options={
          customTriggerOptions === undefined
            ? triggerOptions
            : customTriggerOptions
        }
        defaultValue={
          trigger?.text
            ? {label: trigger?.text ?? '', value: trigger?.text ?? ''}
            : null
        }
        placeholder="Select an event type..."
        onChange={(d: OptionType | null) => {
          if (d) {
            onSelectTrigger(
              projectID,
              artifactCollectionID,
              d.value as EventTriggeringConditionType,
              setTrigger,
              setEventTriggeringConditionType,
              setTriggerScopeType,
              setTriggerScopeID,
              setTriggerArtifactCollectionName
            );
          }
        }}
      />
      {EventConfiguration != null && (
        <div>
          <EventConfiguration
            filters={filters.filters[0]}
            setFilter={(index: number, f: ValueFilter<FilterKey>) => {
              setFilters(Update.setFilter(filters, [0, index], f));
            }}
            pushFilter={(newFilter: ValueFilter<FilterKey>) => {
              setFilters(Update.groupPush(filters, [0], newFilter));
            }}
            deleteFilter={(index: number) =>
              setFilters(Update.groupRemove(filters, [0], index))
            }
            projectName={projectName}
            entityName={entityName}
            setTriggerScopeType={setTriggerScopeType}
            setTriggerScopeID={setTriggerScopeID}
            triggerScopeID={triggerScopeID}
            projectID={projectID}
            triggerScopeType={triggerScopeType}
            artifactCollectionID={artifactCollectionID}
            setTriggerArtifactCollectionName={setTriggerArtifactCollectionName}
          />
        </div>
      )}
    </>
  );
};
